module.exports = __webpack_public_path__ + "2f0399e4214b93706419be238ff91a12.pdf";